import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './MultiMediaViewer.module.scss';
import MultiMediaViewerItem, {
	IMultiMediaViewerItem,
} from './MultiMediaViewerItem';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { cloneDeep } from 'lodash';
import Text from '../../../../Components/Base/Text/Text';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../Hooks/useApiClient';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	files: IMultiMediaViewerItem[];
}

const MultiMediaViewer: React.FC<Props> = ({ files }) => {
	const [isSelectionMode, setIsSelectionMode] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState<IMultiMediaViewerItem[]>(
		[],
	);
	const [isAllFilesSelected, setIsAllFilesSelected] = useState(false);
	const { displayError, displaySuccess } = useApiClient();
	const { t } = useTranslation();

	useEffect(() => {
		setIsAllFilesSelected(files.length === selectedFiles.length);
	}, [selectedFiles]);

	const handleSelectItem = (
		item: IMultiMediaViewerItem,
		isSelected: boolean,
	) => {
		setSelectedFiles(prev => {
			if (isSelected) {
				return [...prev, item];
			}
			return prev.filter(({ id }) => id !== item.id);
		});
	};

	const handleSelectAllDocuments = () => {
		setSelectedFiles(isAllFilesSelected ? [] : cloneDeep(files));
	};

	const handleDownloadDocuments = async () => {
		try {
			const response = await apiClient.post(
				`/document/download/create-multiple`,
				{
					ids: selectedFiles.map(item => item.id),
				},
			);
			displaySuccess(t('component.multiMediaViewer.downloadRequested'));
			setIsSelectionMode(false);
		} catch (e: any) {
			displayError(e);
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				{isSelectionMode ? (
					<>
						<Checkbox
							onChange={handleSelectAllDocuments}
							value={isAllFilesSelected}
							tx='component.multiMediaViewer.markAllFiles'
						/>
						<LinkButton
							title='component.multiMediaViewer.downloadSelectedInPDF'
							theme={Theme.BLUE}
							onClick={() => handleDownloadDocuments()}
						/>
					</>
				) : (
					<>
						<div className={styles.text}>
							<img src='/dist/icons/arrow-pointer-solid.svg' alt='pointer' />
							<Text
								tx='component.multiMediaViewer.youCanShowDetailByClick'
								inline
							/>
						</div>
						<LinkButton
							title='component.multiMediaViewer.downloadDocumentsInPDF'
							theme={Theme.BLUE}
							onClick={() => setIsSelectionMode(true)}
						/>
					</>
				)}
			</div>
			<div className={styles.content}>
				{files.map(item => (
					<MultiMediaViewerItem
						key={item.id}
						item={item}
						isSelectionMode={isSelectionMode}
						isSelected={selectedFiles.some(
							selectedFile => selectedFile.id === item.id,
						)}
						onSelect={handleSelectItem}
					/>
				))}
			</div>
		</div>
	);
};

export default MultiMediaViewer;
